/**
 * BC Precision — business/wholesale nudges (draft theme).
 * Injects a "buying in bulk?" CTA on product pages, right after the price.
 * Cart nudges are handled directly in the cart section/snippet templates.
 */
document.addEventListener('DOMContentLoaded', function () {
  try {
    if (document.querySelector('.bc-wholesale-product-cta')) return;

    var priceEl = document.querySelector('.product__info-container [id^="price-"]');
    if (!priceEl) return;

    var cta = document.createElement('div');
    cta.className = 'bc-wholesale-product-cta';
    cta.style.cssText =
      'margin-top:1.2rem;padding:1rem 1.2rem;border:1px solid rgba(0,0,0,0.12);' +
      'border-radius:8px;font-size:1.4rem;line-height:1.4;';
    cta.innerHTML =
      '<span style="font-weight:600;">Buying in bulk?</span> ' +
      '<a href="/pages/business-wholesale-orders" style="text-decoration:underline;font-weight:600;margin-left:0.3rem;">' +
      'See wholesale pricing &amp; business terms &rarr;</a>';

    priceEl.parentNode.insertBefore(cta, priceEl.nextSibling);
  } catch (e) {
    // Fail silently — never break the product page if the DOM shape changes.
  }
});
